"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeOverride = void 0;
// In order to prevent Theme UI from adding extra elements, which breaks certain layouts,
// we need to use the internal context to change the theme rather than the preferred
// ThemeProvider React component
const core_1 = require("@theme-ui/core");
const react_1 = __importDefault(require("react"));
const Theme_1 = require("./Theme");
const ThemeContext_1 = require("./ThemeContext");
const ThemeOverride = ({ children, mode, themeBrand }) => {
    const _a = react_1.default.useContext(ThemeContext_1.ThemeContext), { mode: modeInitial, brand: themeBrandInitial } = _a, other = __rest(_a, ["mode", "brand"]);
    const modeMerged = mode || modeInitial;
    const brandMerged = themeBrand || themeBrandInitial;
    const theme = react_1.default.useMemo(() => {
        return (0, Theme_1.getTheme)(brandMerged, modeMerged);
    }, [brandMerged, modeMerged]);
    const themeUIContext = react_1.default.useContext(core_1.__ThemeUIContext);
    return (react_1.default.createElement(ThemeContext_1.ThemeContext.Provider, { value: Object.assign(Object.assign({}, other), { mode: modeMerged, brand: brandMerged }) },
        react_1.default.createElement(core_1.__ThemeUIInternalBaseThemeProvider, { context: Object.assign(Object.assign({}, themeUIContext), { theme: theme }) }, children)));
};
exports.ThemeOverride = ThemeOverride;
//# sourceMappingURL=ThemeOverride.js.map